module.exports = __webpack_public_path__ + "img/WMCamp.15d0cf4c.png";